import { Injectable } from '@angular/core';
import { Notification, UtilService, ApiService } from '../shared/index';
import { IListingCategorySearchService } from './ilisting-category-search.service';
import { ListingCategorySearchParams } from './listing-category-search-params.model';
import { ListingCategory } from './listing-category.model';
import { ListingCategorySearchResult } from './listing-category-search-result.model';

@Injectable()
export class ListingCategoryService implements IListingCategorySearchService {
  public _utilService: UtilService;
  public _apiService: ApiService;

  public constructor(utilService: UtilService, apiService: ApiService) {
    this._utilService = utilService;
    this._apiService = apiService;
  }

  public search(params: ListingCategorySearchParams): Promise<ListingCategorySearchResult> {
    const url = '/ListingCategories';
    return this._apiService.getPaged(url, params);
  }

  get(categoryId: number): Promise<ListingCategory> {
    const url = `/ListingCategory/${categoryId}`;
    return this._apiService.get(url);
  }

  create(categoryCode: ListingCategory): Promise<void> {
    const url = `/ListingCategories`;
    return this._apiService.post(url, categoryCode);
  }

  update(categoryCode: ListingCategory): Promise<void> {
    const url = `/ListingCategory/${categoryCode.CategoryID}`;
    return this._apiService.put(url, categoryCode);
  }

  delete(categoryId: number): Promise<void> {
    const url = `/ListingCategory/${categoryId}`;
    return this._apiService.delete(url);
  }
}
